import { render, staticRenderFns } from "./GerbangTol.vue?vue&type=template&id=5a589d9c&scoped=true"
import script from "./GerbangTol.vue?vue&type=script&lang=js"
export * from "./GerbangTol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a589d9c",
  null
  
)

export default component.exports